import { render, staticRenderFns } from "./SimpleGallery.vue?vue&type=template&id=3d86ddfd&scoped=true&"
import script from "./SimpleGallery.vue?vue&type=script&lang=js&"
export * from "./SimpleGallery.vue?vue&type=script&lang=js&"
import style0 from "./SimpleGallery.vue?vue&type=style&index=0&id=3d86ddfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86ddfd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VPagination,VRow})
